import { IProps } from "./chat-variable-field-values.types";
import { VariableType } from "@edgetier/types";
import { DetailsFieldValue, SplitTimestamp } from "@edgetier/client-components";
import { parseISO } from "date-fns";
import { unreachableCaseError } from "@edgetier/utilities";
import "./chat-variable-field-values.scss";

/**
 * Using the variable type return a parsed value of interaction detail value
 * @param props.value
 * @param props.variableType
 */
function ChatVariableFieldValues({ value, variableType }: IProps) {
    const valueText = Array.isArray(value) && value.length > 0 ? value.join(",") : value.toString().trim();

    switch (variableType) {
        case VariableType.Boolean:
            return (
                <DetailsFieldValue copyText={valueText === "true" ? "Yes" : "No"}>
                    {valueText === "true" ? "Yes" : "No"}
                </DetailsFieldValue>
            );
        case VariableType.String:
        case VariableType.Numeric:
        case VariableType.Link:
        case VariableType.Array:
            return (
                <DetailsFieldValue copyText={valueText !== "" ? valueText : "None"}>
                    {valueText !== "" ? valueText : "None"}
                </DetailsFieldValue>
            );
        case VariableType.Date:
        case VariableType.Time:
            return (
                <DetailsFieldValue copyText={valueText !== "" ? valueText : "None"}>
                    {valueText !== "" ? <SplitTimestamp date={parseISO(valueText)} /> : <>None</>}
                </DetailsFieldValue>
            );
        default:
            unreachableCaseError(variableType);
            return <>{value}</>;
    }
}

export default ChatVariableFieldValues;
